import React from "react"
import { uniq } from "lodash"
import { Table } from "react-bootstrap"

import "./PermissionsTable.less"

const PermissionsTable = ({ permissionsList, user }) => {
  const userPermissionsSet = new Set(user.permissions)

  const verbs = uniq(permissionsList.map(p => p.verb))
  const collections = uniq(permissionsList.map(p => p.collection))

  console.log({
    verbs, 
    collections, 
    permissionsList,
    userPermissionsSet
  })

  return (
    <Table striped bordered className="userPermissionTable">
      <thead>
        <tr>
          <th></th>
          {verbs.map(verb => <td>{verb}</td>)}
          
        </tr>
      </thead>
      <tbody>
        {
          collections.map(collection  => (
            <tr key={collection}>
              <td>{ collection }</td>

              {
                verbs.map(verb => {
                  const permission = permissionsList.find(p => p.collection == collection && p.verb == verb)
                  const userHasIt = userPermissionsSet.has(permission._id)
                  return (
                    <td key={verb}>{userHasIt ? "✔️" : "❌"}</td>
                  )
                })

              }
              
            </tr>
          ))
        }
      </tbody>
    </Table>
  )
}

export default PermissionsTable
